import { Injectable } from '@angular/core'

import { AngularFireDatabase } from 'angularfire2/database'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/observable/if'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/take'
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/observable/defer'

import { NotificationService } from '../../notification/shared/notification.service'

import { User } from '../../shared/user.model'
import { Message } from '../../chatroom/shared/message.model'
import { MessageType } from '../../chatroom/shared/message-type.enum'
import { MessageData } from '../../chatroom/shared/message-data.model'
import { Movie } from '../../movies/shared/movie.model'
import { Conversation } from '../../chatroom/shared/conversation.model'
import { UserService } from '../../users/users.module'
import { CreditService } from '../../consumables/consumables.module'
import { TranslateService } from '@ngx-translate/core'

import * as firebase from 'firebase'

import { environment } from '../../../environments/environment'

@Injectable()
export class ConversationService {

  private readonly firebaseRef: firebase.database.Reference = firebase.database().ref(environment.firebaseRoot)
  private readonly storageRef: firebase.storage.Reference = firebase.storage().ref(environment.firebaseRoot)

  constructor(private db: AngularFireDatabase,
    private userService: UserService,
    private creditService: CreditService,
    private translateService: TranslateService,
    private notificationService: NotificationService) { }

  getListByUser(uid: string): Observable<Conversation[]> {
    const chatsRef = this.firebaseRef.child(`/users/${uid}/chats`)
    const chatList$ = this.db.list(chatsRef) as Observable<any>

    const blockedUsers$ = this.userService.getBlockedUsers(uid)

    return chatList$
      .map((items: any) => items.map((item: any) => item.$value))
      .flatMap((result: string[]) => {

        if (result.length === 0) {
          return Observable.of([])
        }

        const observableBatch: Observable<any>[] = []
        result.map((conversationKey: string) => observableBatch.push(this.getConversation(uid, conversationKey).take(1)))

        return Observable.combineLatest(Observable.forkJoin(observableBatch), blockedUsers$)

      })
      .map((result: any) => {
        const conversations: Conversation[] = result[0]
        const blockedUsers: User[] = result[1]
        return conversations
          .filter((conversation: Conversation) => {
            console.log(conversation)
            return !!!blockedUsers.find((user: User) => {
              return conversation.otherUserUid === user.uid
            })
          })
      })
      .do(a => console.log(a))
      // .map((result: any[]) => result.map((item: any) => this.mapToConversation(uid, item)))
      // .map((conversations: Conversation[]) => {
        // for (let i = 0; i < conversations.length; i++) {
          // const otherUid = conversations[i].senderUid === uid ? conversations[i].receiverUid : conversations[i].senderUid

          // const userRef = this.firebaseRef.child(`/users/${otherUid}`)
          // conversations[i].otherUser = this.db.object(userRef).first()
        // }

        // return conversations
      // })
  }

  getConversation(uid: string, key: string): Observable<Conversation> {
    const chatroomRef = this.firebaseRef.child(`/chatrooms/${key}`)
    return this.db.object(chatroomRef)
      .map((conversation: any) => this.mapToConversation(uid, conversation))
  }

  createConversation(senderUid: string, receiverUid: string, movie: Movie): Promise<any> {

    const senderRef = this.firebaseRef.child(`/users/${senderUid}`)
    let conversationId: string = null

    return <Promise<any>>senderRef.once('value')
      .then((snapshot: firebase.database.DataSnapshot) => {
        const updates = {}

        const receiverChatRef = snapshot.child(`chats/${receiverUid}`)
        if (receiverChatRef.exists()) {
          conversationId = receiverChatRef.val()
        }

        const subExpiryDate: number = snapshot.child('subExpiryDate').val()
        const currentCredits: number = snapshot.child('credits').val()

        if ((!subExpiryDate || subExpiryDate < (+new Date())) && currentCredits <= 0) {
          throw new Error('Not enough credits')
        }

        if (conversationId === null) {
          conversationId = this.firebaseRef.child('chatrooms').push().key

          const chatroomData = {
            conversationHasStarted: false,
            lastText: '',
            timeStamp: firebase.database.ServerValue.TIMESTAMP,
            uuidSender: senderUid,
            uuidReceiver: receiverUid,
            senderRead: true,
            receiverRead: false,
            senderDeleted: false,
            receiverDeleted: false
          }

          updates['/chatrooms/' + conversationId] = chatroomData
          updates['/users/' + senderUid + '/chats/' + receiverUid] = conversationId
          updates['/users/' + receiverUid + '/chats/' + senderUid] = conversationId
        }

        return this.firebaseRef.update(updates)
      })
      .then(() => {
        return this.creditService.consumeCredit(senderUid)
      })
      .then(() => {
        // Load chatroom
        return this.firebaseRef.child(`chatrooms/${conversationId}`).once('value')
      })
      .then((snapshot: firebase.database.DataSnapshot) => {
        return this.onAfterConversationCreated(senderUid, receiverUid, snapshot)
      })
      .then(() => {
          const message: Message = {
              conversationId: conversationId,
              senderUid: senderUid,
              targetUid: receiverUid,
              type: MessageType.Invite,
              text: this.translateService.instant('genericInvite'),
          }


          if (movie) {
            message.movieTitle = movie.getTitle(this.translateService.currentLang)
            message.image = movie.getBannerUrl(this.translateService.currentLang)
            message.duration = movie.duration
            message.rating = movie.rating
            message.text = this.translateService.instant('inviteMovieTitle') + ' ' + movie.getTitle('en')
          }

          return this.sendMessage(message)
      })
  }

  getMessages(conversationId: string): Observable<Message[]> {
    const messagesRef = this.firebaseRef.child(`/chats/${conversationId}`)

    return this.db.list(messagesRef)
      .switchMap((items: any) => {
        const messages: Message[] = []
        const observableBatch = []

        for (const item of items) {
          const message: Message = {
              id: item.$key,
              conversationId: conversationId,
              senderUid: item.userID,
              type: MessageType.getTypeFromString(item.messageText.type),
              text: item.messageText.text,
              timestamp: item.messageTime,
          }

          if (message.type === MessageType.Invite) {
            message.movieTitle = item.messageText.movieTitle
            message.image = item.messageText.image
          }

          if (message.type === MessageType.Image) {
            const observable = Observable
              .defer(() => {
                return this.getImageUrl(message, item.messageText.image)
              })
              .do((url: string) => message.image = url)
              // .do((a) => console.log(messages))

            observableBatch.push(observable)
          }

          messages.push(message)
        }

        if (observableBatch.length > 0) {
          return Observable
            .forkJoin(observableBatch)
            .mapTo(messages)
        }

        return Observable.of(messages)
          // .combineLatest(observableBatch, messages, (a, b) => {console.log(a, b); return messages})
      })

      // .do( a => console.log(a))



    // const messages$ = this.db.list(messagesRef)
    //   .flatMap((result: any) => {
    //     return result
    //   })
    //   .map((item: any) => {
    //     const message: Message = {
    //         id: item.$key,
    //         conversationId: conversationId,
    //         senderUid: item.userID,
    //         type: MessageType.getTypeFromString(item.messageText.type),
    //         text: item.messageText.text,
    //         timestamp: item.messageTime,
    //     }

    //     if (message.type === MessageType.Invite) {
    //       message.movieTitle = item.messageText.movieTitle
    //       message.image = item.messageText.image
    //     }

    //     return message
    //   })

    // const [images, others] = messages$.partition((message: Message) => message.type === MessageType.Image)

    // return Observable.merge(
    //   images.concatMap((message: Message) => {
    //     return Observable.defer(() => {
    //       return this.getImageUrl(message)
    //     })
    //   }),
    //   others
    // )
    // .do(a => console.log(a))

      // .concatMap((message: Message) => {
      //   return Observable.defer(() => {
      //     return this.getImageUrl(message)
      //   })
      // })

      // .map((result: any[]) => {
      //   const messages: Message[] = []

      //   for (const item of result) {
      //     const message: Message = {
      //       id: item.$key,
      //       conversationId: conversationId,
      //       senderUid: item.userID,
      //       type: MessageType.getTypeFromString(item.messageText.type),
      //       text: item.messageText.text,
      //       timestamp: item.messageTime,
      //     }

      //     if (message.type === MessageType.Image) {
      //       this.storageRef.child(`chatAssets/${conversationId}/${item.messageText.image}`).getDownloadURL()
      //         .then((url) => {
      //           message.image = url
      //         })
      //     }

      //     if (message.type === MessageType.Invite) {
      //       message.movieTitle = item.messageText.movieTitle
      //       message.image = item.messageText.image
      //     }

      //     messages.push(message)
      //   }

      //   return messages
      // })
  }

  sendMessage(message: Message): Promise<any> {
    return this.getConversation(message.senderUid, message.conversationId)
      .take(1)
      .toPromise()
      .then((conversation: any) => {
        if (message.type === MessageType.Invite || !conversation.isDisabled) {

          const newMessageKey = this.firebaseRef.child(`/chats/${message.conversationId}`).push().key
          message.id = newMessageKey

          if (message.type === MessageType.Image) {
            return this.storageRef
              .child(`chatAssets/${message.conversationId}/${newMessageKey}`)
              .putString(message.image, 'data_url')
              .then(() => {
                message.image = newMessageKey
                this.addMessageToDatabase(conversation, message)
              })
          }

          return this.addMessageToDatabase(conversation, message)

          // const message: Message = {
          //     messageText: {
          //         text: message,
          //         type: type
          //     },
          //     messageTime: firebase.database.ServerValue.TIMESTAMP,
          //     userID: uid
          // }
        }
      })
  }

  public setAsRead(conversationId: string, uid: string) {
    const conversationRef = this.firebaseRef.child(`chatrooms/${conversationId}`)
    conversationRef.once('value')
      .then((item: firebase.database.DataSnapshot) => {
        const conv = item.val()
        if (conv.uuidSender === uid) {
          conv.senderRead = true
        } else {
          conv.receiverRead = true
        }

        return conversationRef.set(conv)
      })
  }

  private addMessageToDatabase(conversation: any, message: Message): Promise<any> {
    const updates = {}
    updates['/chats/' + message.conversationId + '/' + message.id] = {
      userID: message.senderUid,
      messageTime: firebase.database.ServerValue.TIMESTAMP,
      messageText: {
        type: MessageType.toString(message.type),
        text: message.text || null,
        movieTitle: message.movieTitle || null,
        image: message.image || null,
        runTime: message.duration || null,
        stars: message.rating || null
      }
    }

    updates['/chatrooms/' + message.conversationId + '/lastText'] = (message.type === MessageType.Image)
      ? 'vous a envoyé une image'
      : message.text
    updates['/chatrooms/' + message.conversationId + '/timeStamp'] = firebase.database.ServerValue.TIMESTAMP
    updates['/chatrooms/' + message.conversationId + '/receiverRead'] = conversation.isReceiver
    updates['/chatrooms/' + message.conversationId + '/senderRead'] = conversation.isSender
    updates['/chatrooms/' + message.conversationId + '/senderDeleted'] = false
    updates['/chatrooms/' + message.conversationId + '/receiverDeleted'] = false

    if (message.type !== MessageType.Invite && conversation.hasStarted === false) {
      updates['/chatrooms/' + message.conversationId + '/conversationHasStarted'] = true
    }

    let notificationType = 'NEW_CHAT'
    if (message.type === MessageType.Invite) {
      notificationType = 'INVITATION'
    }

    this.notificationService.notify(message.senderUid, message.targetUid, message.conversationId, notificationType)

    return this.firebaseRef.update(updates) as Promise<any>
  }

  private getImageUrl(message: Message, imageId: string): Promise<string> {
    return <Promise<any>>this.storageRef
      .child(`chatAssets/${message.conversationId}/${imageId}`)
      .getDownloadURL()
  }

  private onAfterConversationCreated(senderUid: string, receiverUid: string, snapshot: firebase.database.DataSnapshot) {
    // Start conversation if receiver user reply to initial invitation
    const conversationId = snapshot.key

    const updates = {}
    if (snapshot.child('uuidReceiver').val() === senderUid) {
      updates[`chatrooms/${conversationId}/conversationHasStarted`] = true
    }

    return this.firebaseRef.update(updates)
  }

  private mapToConversation(uid: string, item: any): Conversation {
    const conversation = new Conversation()

    conversation.id = item.$key
    conversation.hasStarted = item.conversationHasStarted
    conversation.lastText = item.lastText
    conversation.timestamp = item.timeStamp
    conversation.senderUid = item.uuidSender
    conversation.receiverUid = item.uuidReceiver
    conversation.senderRead = item.senderRead
    conversation.receiverRead = item.receiverRead
    conversation.senderDeleted = item.senderDeleted
    conversation.receiverDeleted = item.receiverDeleted
    conversation.isSender = item.uuidSender === uid

    return conversation
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/conversation/conversation.service.ts